import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="71.603" height="71.603" viewBox="0 0 71.603 71.603">
    <g id="color-upload" transform="translate(1.75 1.75)">
      <path
        id="Caminho_237"
        data-name="Caminho 237"
        d="M72.6,22.5V37.634A7.567,7.567,0,0,1,65.036,45.2H12.067A7.567,7.567,0,0,1,4.5,37.634V22.5"
        transform="translate(-4.5 22.902)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
      />
      <path
        id="Caminho_238"
        data-name="Caminho 238"
        d="M48.335,23.418,29.418,4.5,10.5,23.418"
        transform="translate(4.634 -4.5)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
      />
      <path
        id="Caminho_239"
        data-name="Caminho 239"
        d="M18,4.5V49.9"
        transform="translate(16.052 -4.5)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
      />
    </g>
  </svg>,
  'ColorUploadIcon',
);
